module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"learn_more":"Learn more","try_it_now":"Try it now","new_features_not_found":"New features not found or empty"},"id":{"learn_more":"Pelajari selengkapnya","try_it_now":"Coba sekarang","new_features_not_found":"Fitur baru tidak ditemukan"}}')
  delete Component.options._Ctor
}
